import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { SpinnerService } from '../../../shared/spinner.service'
import { DomSanitizer } from "@angular/platform-browser";
import { ComplaintsService } from '../../service/complaints.service'
import { session } from '../../../../environments/environment.session'
import swal from 'sweetalert2';
import { MainService } from '../../service/main.service'
import { TranslationService } from '../../service/translation.service';
import { FileUploadService } from '../../service/file-upload.service'
import { PdfGeneratorService } from '../../service/pdf-generator.service';
@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.css']
})
export class PreviewComponent {
  prevViewFileObj: any = {};
  erpUser: any
  constructor(private pdfService: PdfGeneratorService, private fus: FileUploadService, private location: Location, private router: Router, private tspinner: SpinnerService, private sanitizer: DomSanitizer, private cs: ComplaintsService, public main: MainService, public translation: TranslationService) {
    const nav = this.router.getCurrentNavigation();
    if (nav && nav.extras && nav.extras.state && nav.extras.state['data']) {
      this.prevViewFileObj = nav.extras.state['data'];
      console.log(this.prevViewFileObj)
    } else {
      if (!this.prevViewFileObj || Object.keys(this.prevViewFileObj).length == 0) {
        this.router.navigate(['/sdp/operator/dashboard'])
        return
      }
    }
  }
  @ViewChild('comDocInput') comDocInput!: ElementRef;
  @ViewChild('othersDocInput') othersDocInput!: ElementRef;
  @ViewChild('resolvedDocInput') resolvedDocInput!: ElementRef;
  async ngOnInit() {
    try {
      this.tspinner.show('', '')
      this.erpUser = JSON.parse(atob(session.erpUser));
      if (!this.prevViewFileObj['com_id']) {
        return
      }
      await this.getFilesLog()
      this.tspinner.hide()
    } catch (err) {
      this.tspinner.hide()
    }

  }

  logs = []
  appr_flag = false
  async getFilesLog() {

    let resp = await this.main.getFilesLog(JSON.stringify({ b_acct_id: this.erpUser.b_acct_id, com_id: this.prevViewFileObj['com_id'] }))
    if (resp['error'] == false) {
      this.logs = resp['data']
      if(this.logs.length>0){
        this.appr_flag =['PENDING','RESOLVED'].includes( this.logs[this.logs.length-1]['status']) && this.erpUser.le_id == this.logs[this.logs.length-1]['user_id'] ? true : false;
      }
      return
    } else {
      swal.fire(this.translation.t('common', 'errorTitle'), resp['data'], 'error')
      return
    }
  }

  back() {
    this.location.back();
  }
  imgURL: any
  async viewDoc(obj: any, doc: any, doc_type: string) {
    if (obj[doc] == 'N/A') {
      return
    }
    if (obj[doc]) {
      this.tspinner.show('', '')
      let ob = { b_acct_id: this.erpUser.b_acct_id, doc_name: obj[doc], doc_type: doc_type, doc_id: obj.com_id }
      const res = await this.cs.viewDoc(ob);
      if (res) {
        var docname = obj[doc];
        var ext = docname.split(".");
        if (
          ext[1] == "png" ||
          ext[1] == "jpeg" ||
          ext[1] == "jpg" ||
          ext[1] == "PNG" ||
          ext[1] == "JPEG" ||
          ext[1] == "JPG"
        ) {
          let file = new Blob([res], { type: "image/png" });
          var fileURL = window.URL.createObjectURL(file);
          this.imgURL = this.sanitizer.bypassSecurityTrustUrl(fileURL);
          this.tspinner.hide();
          window.open(fileURL, "_blank");
        } else if (ext[1].toLowerCase() == "xlsx") {
          let file = new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.tspinner.hide();
        } else if (
          ext[1].toLowerCase() == "docx" ||
          ext[1].toLowerCase() == "doc"
        ) {
          let file = new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.tspinner.hide();
        } else {
          let file = new Blob([res], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.tspinner.hide();
        }
      } else {
        this.tspinner.hide();
      }
    } else {
      this.tspinner.hide();
      swal.fire(this.translation.t('common', 'errorTitle'), this.translation.t('preview', 'noDocumentUploaded'), "error");
    }
  }

  // uploadDoc(arg0: string) {
  //   throw new Error('Method not implemented.');
  // }

  //  onFileSelected(event: Event, fieldName: string): void {
  //   const input = event.target as HTMLInputElement;
  //   if (input.files && input.files.length > 0) {
  //     const file = input.files[0];
  //     console.log('Selected file:', file);

  //     // You can now assign it to your model or send it to a service
  //     // this.uploadFile(file, fieldName);
  //   }
  // }


  // editMode: boolean = false;
  // selectedFile: File | null = null;

  // onEditClick(change: string) {
  //   this.editMode = true;
  // }

  // onFileSelected(event: any, change: string) {
  //   if (event.target.files.length > 0) {
  //     this.selectedFile = event.target.files[0];
  //   }
  // }

  // uploadDoc(docKey: string) {
  //   if (this.selectedFile) {
  //     this.prevViewFileObj[docKey] = this.selectedFile.name;
  //     this.editMode = false;
  //     this.selectedFile = null;
  //   }
  // }

  obj: any = {}
  selectedFileUrlObj: any = {}
  async checkFile(event: any, doc: any) {
    this.tspinner.show('', '')
    let resp: boolean = await this.fus.validatePdfSize(event);

    if (this.selectedFileUrlObj[doc] && this.selectedFileUrlObj[doc]['url']) {
      URL.revokeObjectURL(this.selectedFileUrlObj[doc]);
    }
    this.selectedFileUrlObj[doc] = {}

    if (!resp) {
      this.tspinner.hide()
      this.selectedFileUrlObj[doc] = {}
      switch (doc) {
        case 'com':
          this.comDocInput.nativeElement.value = '';
          break;
        case 'others':
          this.othersDocInput.nativeElement.value = '';
          break;
        case 'resolved':
          this.resolvedDocInput.nativeElement.value = '';
          break;

        default:
          console.log("switch");
          break;
      }
      this.selectedFileUrlObj[doc]['url'] = undefined
      this.selectedFileUrlObj[doc].event = undefined;
      this.selectedFileUrlObj[doc].file_name = undefined;
    }

    this.tspinner.hide()
    const file: File = event.target.files[0];
    this.selectedFileUrlObj[doc]['url'] = URL.createObjectURL(file);
    this.selectedFileUrlObj[doc].event = event.target.files[0]
    this.selectedFileUrlObj[doc].file_name = event.target.files[0]['name'];

  }




  async upload(up_doc: string) {
    let data = new FormData();
    let doc = []
    let obj: any = { com_id: this.prevViewFileObj['com_id'], b_acct_id: this.erpUser.b_acct_id, create_user_id: this.erpUser.le_id }
    if (up_doc == 'com' && this.selectedFileUrlObj['com'] && this.selectedFileUrlObj['com']['file_name']) {
      data.append('file', this.selectedFileUrlObj['com']['event']);
      doc.push({ doc_type: 'com', doc_name: this.selectedFileUrlObj['com']['file_name'] })
      obj['doc_name'] = this.selectedFileUrlObj['com']['file_name']
      obj['upload_doc'] = 'com_doc'
    }

    if (up_doc == 'others' && this.selectedFileUrlObj['others'] && this.selectedFileUrlObj['others']['file_name']) {
      data.append('file', this.selectedFileUrlObj['others']['event']);
      doc.push({ doc_type: 'others', doc_name: this.selectedFileUrlObj['others']['file_name'] })
      obj['doc_name'] = this.selectedFileUrlObj['others']['file_name']
      obj['upload_doc'] = 'others_doc'
    }

    if (up_doc == 'resolved' && this.selectedFileUrlObj['resolved'] && this.selectedFileUrlObj['resolved']['file_name']) {
      data.append('file', this.selectedFileUrlObj['resolved']['event']);
      doc.push({ doc_type: 'resolved', doc_name: this.selectedFileUrlObj['resolved']['file_name'] })
      obj['doc_name'] = this.selectedFileUrlObj['resolved']['file_name']
      obj['upload_doc'] = 'resolved_doc'
    }
    obj['doc'] = doc
    console.log(obj)
    data.append('data', JSON.stringify(obj));
    this.tspinner.show('', '')
    let resp = await this.cs.uploadComplaintsDoc(data)
    if (resp['error'] == false) {
      this.tspinner.hide()
      if (await this.getComplaints()) {
        swal.fire(this.translation.t('common', 'successTitle'), this.translation.t('preview', 'uploadSuccess'), 'success')
        return
      }
    }

    swal.fire(this.translation.t('common', 'oopsTitle'), this.translation.t('preview', 'uploadFailed'), 'error')

  }


  async getComplaints() {
    let resp: any = await this.cs.getComplaints(JSON.stringify({ b_acct_id: this.erpUser.b_acct_id, com_id: this.prevViewFileObj['com_id'] }))
    if (resp['error'] == false) {
      this.prevViewFileObj = resp['data'][0]
      return true
    } else {
      return false
    }
  }

  onDownloadPDF(obj: any) {
    const b_acct_id = this.erpUser.b_acct_id;
    this.pdfService.generateComplaintPDF(b_acct_id, obj.com_id);
  }
  route(element: any) {
    this.router.navigate(['/sdp/officer/update-complaints'], {
      state: { data: element }
    });
  }

}

